import { useState, useEffect } from 'react';

const faqs = [
  {
    question: '初めての鍼灸治療ですが、痛くないですか?',
    answer: '鍼は髪の毛ほどの細さで、ほとんど痛みを感じません。むしろ心地よい刺激として感じる方が多いです。初めての方には特に丁寧に説明しながら施術いたしますので、ご安心ください。',
  },
  {
    question: '1回の施術時間はどのくらいですか?',
    answer: '初回はカウンセリングを含めて約60分、2回目以降は約40〜50分程度です。症状や施術内容によって多少前後することがあります。',
  },
  {
    question: '健康保険は使えますか?',
    answer: '医師の同意書がある場合、一部の症状について健康保険が適用されます。詳しくはお電話またはご来院時にお問い合わせください。',
  },
  {
    question: 'どのくらいの頻度で通えばいいですか?',
    answer: '症状や体質によって異なりますが、急性の症状では週1〜2回、慢性的な症状では週1回程度をおすすめしています。症状が改善してきたら、徐々に間隔を空けていきます。',
  },
  {
    question: '予約は必要ですか?',
    answer: '当院は完全予約制となっております。お電話またはウェブサイトからご予約ください。当日予約も可能な場合がありますので、お気軽にお問い合わせください。',
  },
  {
    question: '駐車場はありますか?',
    answer: '専用駐車場を3台分ご用意しております。満車の場合は近隣のコインパーキングをご利用ください。',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const siteUrl = typeof VITE_SITE_URL !== 'undefined' ? VITE_SITE_URL : 'https://example.com';
    
    const schemaId = 'faq-schema';
    let schemaScript = document.getElementById(schemaId);
    
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': `${siteUrl}/#faq`,
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };

    if (schemaScript) {
      schemaScript.textContent = JSON.stringify(schema);
    } else {
      schemaScript = document.createElement('script');
      schemaScript.id = schemaId;
      schemaScript.type = 'application/ld+json';
      schemaScript.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }

    return () => {
      const script = document.getElementById(schemaId);
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <div className="inline-block bg-sub px-4 py-1 rounded-full mb-4">
            <span className="text-primary text-xs font-medium tracking-wider uppercase">FAQ</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4 px-4">
            よくある<strong>ご質問</strong>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base px-4">
            <strong>岡山市の鍼灸院</strong>について、患者様からよくいただく質問をまとめました
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <article
              key={index}
              className="bg-sub/30 rounded-xl sm:rounded-2xl overflow-hidden hover:bg-sub/40 transition-colors cursor-pointer"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-5 md:py-6 flex items-center justify-between text-left"
              >
                <h3 className="font-semibold text-gray-900 text-sm sm:text-base pr-3 sm:pr-4" itemProp="name">
                  {faq.question}
                </h3>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl sm:text-2xl text-primary transition-transform flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <div className="px-4 sm:px-6 md:px-8 pb-4 sm:pb-5 md:pb-6">
                  <p className="text-gray-700 text-xs sm:text-sm leading-relaxed" itemProp="text">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
